import React from 'react'
import PropTypes from 'prop-types'

import { SEARCH_CONTROL_RESULT } from '../../constants'

import styles from './SearchResult.scss'

const SearchResult = ({ result }) => {
    if (!result) {
        return null
    }

    return (
        <div className={styles.base}>
            <span className={styles.description}>{SEARCH_CONTROL_RESULT}</span>
            <span className={styles.name}>{result.trim()}</span>
        </div>
    )
}

SearchResult.propTypes = {
    result: PropTypes.string,
}

export default SearchResult



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/SearchResult/SearchResult.jsx